import { __awaiter, __generator, __read } from "tslib";
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { fetchOfficeComponentContext } from '@office-start/component-context-service';
import { queryCache } from '@office-start/data-fetching';
import { fetchIdentity } from '@office-start/identity-service';
import { fetchTemplatesConfig } from '@office-start/templates-config-service';
import { executeTemplateContentDataFlow } from '../data-flows/executeTemplateContentDataFlow';
export function getTemplateContentData(app, templateId, templateBinaryUrl) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, componentContext, identity, templatesConfig, queryKey;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        fetchOfficeComponentContext(),
                        fetchIdentity(),
                        fetchTemplatesConfig(),
                    ])];
                case 1:
                    _a = __read.apply(void 0, [_b.sent(), 3]), componentContext = _a[0], identity = _a[1], templatesConfig = _a[2];
                    queryKey = [
                        'TemplateContentData',
                        templateId,
                        componentContext.preferredCulture,
                    ];
                    return [2 /*return*/, queryCache.fetchQuery(queryKey, function () {
                            return executeTemplateContentDataFlow(app, templateId, templateBinaryUrl, identity, componentContext, templatesConfig, function (freshData) {
                                return queryCache.setQueryData(queryKey, freshData);
                            });
                        }, {
                            staleTime: Infinity,
                            cacheTime: Infinity,
                            enabled: componentContext && identity && templatesConfig,
                        })];
            }
        });
    });
}
//# sourceMappingURL=getTemplateContentData.js.map